
import { useDispatch, useSelector} from 'react-redux'
import { useEffect, useState } from 'react';
import { Text,Image,  Group, createStyles, Container, Paper, Alert, Loader, } from '@mantine/core';
import GuestMain from './GuestMain';

import ntbslogo from "./images/logo.png";
import intl from 'react-intl-universal';
import deDE from '../app/locales/de_DE.json'
import enUS from '../app/locales/en_US.json'
import { InfoCircle } from 'tabler-icons-react';

const useStyles = createStyles((theme) => ({
  headerbg: {
    backgroundColor: "#ffffff",	
  },
  contback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },
  paper: { 
    minWidth: 600,
  },

}));


const LOCALES_LIST = [
  {
    label: "DE",
    value: "de-DE",
  },
  {
    label: "EN",
    value: "en_US",
  },
];

const LOCALE_DATA = {
    "de_DE": deDE,
    "en_US": enUS,
  }




const GuestDash = () => {
    const dispatch = useDispatch()
    const { classes } = useStyles();
    const guestsignalrconnected = useSelector((state: any) => state.user.guestconnected)
    const guest_isValid = useSelector((state: any) => state.user.guest_isValid)
    const tabnotactive = useSelector((state: any) => state.user.guest_notactive)
    const guestalreadyimmeeting = useSelector((state: any) => state.user.guest_already_inmeeting)
   


    const params = new URLSearchParams(window.location.search);
    const hashParam = params.get('hash');

    let currentLocale = useSelector((state: any) => state.user.clientlanguage)
    const [initDone, setInitDone] = useState(false);

    const icon = <InfoCircle />;
  

    useEffect(() => {
        if (!guestsignalrconnected){
            // Connect to SignalR hub
             dispatch({ type: 'SIGNALR_CONNECT_GUEST' });
        }

        if (guestsignalrconnected){
            console.log("wsCONNECTED: " + guestsignalrconnected)

            const payload = {
                hash: hashParam,
              };
              // Request Startmeeting
              dispatch({ type: 'GUEST_SIGNALR_CHECKHASH', payload: payload });

       
        // Set Listener to SignarR
        const signalrActions = [
            { type: 'GUEST_SIGNALR_RECIVE_HASHCONFIRM', eventName: "OnValidateHash" },
            { type: 'GUEST_SIGNALR_RECIVEMEETINGDATA', eventName: "OnGetGastMeetingInitData" },
            { type: 'GUEST_SIGNALR_RECIVEJOINLINK', eventName: "OnRequestGastJoinLink" },
            { type: 'SIGNALR_ON_ARCHIVEDMEETING', eventName: "OnArchivedMeeting" },
            { type: 'GUEST_SIGNALR_ON_UPDATEMEETINGPARTICIPANTS', eventName: "OnUpdateMeetingAndParticipantsData" },
            { type: 'GUEST_SIGNALR_ON_NOTIFICATIONNOTARINMEETING', eventName: "OnNotificateGastsNotarInMeeting" },
            { type: 'GUEST_SIGNALR_ON_OPENLASTACTIVELINK', eventName: "OnOpenLastActiveLink" },
            { type: 'GUEST_SIGNALR_ON_LINKNOTACTIVE', eventName: "OnLinkNotActive" },
            { type: 'GUEST_SIGNALR_ON_INVITEGUESTFROMVK', eventName: "OnInviteGuestFromVk" },
            { type: 'GUEST_SIGNALR_ONBLOCKGUESTFROMVK', eventName: "OnBlockGuestFromVk" },
            { type: 'GUEST_SIGNALR_RECIVEONHANDLEDOCUMENT', eventName: "OnHandleDocument" },
          ];
    
          signalrActions.forEach(action => {
            dispatch({ type: action.type, eventName: action.eventName });
          });
        }


    }, [dispatch, guestsignalrconnected, hashParam]);


    /**
    * Initializes the internationalization settings.
    */
   const initializeIntl = () => {
    // 2. Fallback to "de-DE" if the currentLocale isn't supported in LOCALES_LIST
    if (!LOCALES_LIST.some(item => item.value === currentLocale)) {
      currentLocale = "de_DE"
    }
    setCurrentLocale(currentLocale);
    setInitDone(true);
  }

  /**
   * Set the current locale for internationalization.
   *
   * @param {string} currentLocale - The new locale to set.
   * @return {void} 
   */
  const setCurrentLocale = (currentLocale: string) => {
    intl.init({
      currentLocale,
      locales: LOCALE_DATA,
    });
  };

    if (!initDone){
      initializeIntl();
    } else {
      setCurrentLocale(currentLocale)
    }



  
  return (
    <>
      {guest_isValid === undefined &&
          <Container fluid className={classes.contback}> 
              <Paper shadow="sm" p="xl" className={classes.paper}>
                <Group>
              <Loader color="green" size="xl" />
              <Text>{intl.get('GUESTDASH_CONNECTING')} </Text>
              </Group>
              </Paper>
          </Container>
      }

      {guest_isValid && !tabnotactive &&
        <GuestMain />
      }

      {tabnotactive &&
        <>
        <Container fluid className={classes.contback}> 
          <Paper shadow="sm" p="xl" className={classes.paper}>
          <Group position="center" >
          <Image
             height={75}
             width={220}
             src={ntbslogo}
                 />
           </Group>
          <Group position="center" >
               <Alert variant="filled" color="red" title={intl.get('GUEST_TABNOT_ACTIV')}  icon={icon}>
               {intl.get('GUEST_TABNOT_ACTIV_1')} 
             </Alert>
           </Group>
         </Paper>
         </Container>
           </>
      }

      {guestalreadyimmeeting &&
      <>
        <Container fluid className={classes.contback}> 
        <Paper shadow="sm" p="xl" className={classes.paper}>
        <Group position="center" >
        <Image
           height={75}
           width={220}
           src={ntbslogo}
               />
         </Group>
        <Group position="center" >
             <Alert variant="filled" color="red" title={intl.get('GUEST_USERIN_MEETING')} icon={icon}>
             {intl.get('GUEST_USERIN_MEETING_1')} 
           </Alert>
         </Group>
       </Paper>
       </Container>
       </>
      }

     

   

      {!guest_isValid &&
      <>
       <Container fluid className={classes.contback}> 
         <Paper shadow="sm" p="xl" className={classes.paper}>
         <Group position="center" >
         <Image
            height={75}
            width={220}
            src={ntbslogo}
                />
          </Group>
         <Group position="center" >
              <Alert variant="filled" color="red" title={intl.get('GUESTDASH_HASHWRONG_HEAD')}icon={icon}>
               {intl.get('GUESTDASH_HASHWRONG_CONTENT')}
            </Alert>
          </Group>
        </Paper>
        </Container>
          </>
      }

      


      </>
    );
  }
  
  export default GuestDash;